import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incidents-benutzer-zugriff';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentsBenutzerZugriffEffects {

    IncidentsBenutzerZugriff$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENTS_BENUTZER_ZUGRIFF),
        mergeMap((x: ac.GetIncidentsBenutzerZugriffAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentsBenutzerZugriff().pipe(
                map((result: any) => {
                    return new ac.GetIncidentsBenutzerZugriffErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentsBenutzerZugriffFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
